import axios from "axios";

// Same-origin API base: the platform ingress routes /api to the backend on every
// domain (preview, *.emergent.host, custom domain), so no absolute URL is baked in.
export const API = axios.create({
  baseURL: "/api",
  withCredentials: true,
});

export const imgUrl = (u) => {
  if (!u) return "";
  if (u.startsWith("http") || u.startsWith("data:")) return u;
  return `/api/files/${u}`;
};

export const money = (v) => `£${Number(v || 0).toFixed(2)}`;

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (d?.msg) return d.msg;
  return String(d);
};

export const formatDate = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString("en-GB", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
};
